import { Box } from '@material-ui/core';
import { getPaymentPlanByExternalId } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { PaymentPlanDetailsSection } from '@/components/modules/PaymentPlan/components/PaymentPlanDetailsSection/PaymentPlanDetailsSection';
import { PaymentPlanTableSection } from '@/components/modules/PaymentPlan/components/PaymentPlanTableSection/PaymentPlanTableSection';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { ModuleCorePermissionProps, PendingDataType } from '@/config/types';
import { useCache } from '@/hooks/requests/useCache';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const PaymentPlan = ({ canEdit = false }: ModuleCorePermissionProps) => {
  const { palette } = useCustomTheme();
  const { loanId } = useParams();

  if (!loanId) return null;

  const { data: paymentPlan } = useCache(
    getPaymentPlanByExternalId,
    { externalId: loanId },
    { fallbackData: undefined },
  );

  return !paymentPlan ? (
    <>
      <Box pb={2} borderTop={`1px solid ${palette.grey[200]}`} />
      <PendingDataWarning type={PendingDataType.PAYMENT_PLAN} />
    </>
  ) : (
    <>
      <PaymentPlanDetailsSection paymentPlan={paymentPlan} />
      <Box mt={3} />
      <PaymentPlanTableSection paymentPlan={paymentPlan} editModeAllowed={canEdit} />
    </>
  );
};

export const PaymentPlanModule = withPermissionsModule(PaymentPlan);
